<div class="textarea-wrapper" [ngClass]="{ 'textarea-has-icon': showIcon }">
    <label *ngIf="label">
      {{ label }}
      <span *ngIf="isRequired" class="required-asterisk">*</span>
    </label>
  
    <div *ngIf="showIcon" class="textarea-icon">
      <img class="textarea-icon-img" *ngIf="iconPath" [src]="iconPath" alt="Icon" />
    </div>

    <textarea
      class="text-area"
      [placeholder]="placeholder"
      [maxlength]="isLengthLimited ? maxlength : null"
      [formControl]="control"
      (focus)="onFocus()"
      (blur)="control.markAsTouched()"
      (input)="onTextChanged($event)"
      [ngClass]="{
        'pass-char-number': isLengthLimited && control.value?.length >= characterLimit && isTouched,
        'has-error': hasError('required'),
        'has-icon': showIcon,
        'disabled': isDisabled
      }"
    ></textarea>
  
    <div
      *ngIf="!isDisabled && isLengthLimited && showCharacterCount && !hasError('required')"
      class="character-count"
    >
      <span *ngIf="characterLimit - control.value?.length > 0; else limitReached">
        {{ characterLimit - control.value?.length }} caractères restants
      </span>
      <ng-template #limitReached>
        Vous avez atteint la limite des caractères autorisés
      </ng-template>
    </div>
  
    <span *ngIf="hasError('required') && !isDisabled" class="error-message">
      Ce champ est requis*
    </span>
  </div>
  